<template>
    <router-view>
    </router-view>
</template>

<script>
    export default {
        name: "BaseCatalog"
    }
</script>

<style scoped>

</style>